import SvgClose from "@Components/CustomIcon/SvgClose"
import { BreeSerifText } from "@Components/CustomText/BreeSerifText"
import React, { useState } from "react"
import { Button, Dimensions, Text, View, TouchableOpacity, ScrollView } from "react-native"
import Modal from "react-native-modal"
import styles from "./styles"
import { RFValue } from "react-native-responsive-fontsize"

const CustomScrollableModal = (props) => {
    const { open, toggleModal, title, children, footer, height } = props

    return (
        <Modal
            animationIn="fadeInUp"
            animationOut="fadeOutDown"
            swipeDirection={["down"]}
            animationOutTiming={10}
            //onDismiss={toggleModal}
            isVisible={open}
            onSwipeComplete={toggleModal}
            onBackButtonPress={toggleModal}
            style={styles.container}
        >
            <View style={[styles.content, { height: height ?? undefined }]}>
                <TouchableOpacity onPress={toggleModal} style={styles.closeIcon}>
                    <SvgClose />
                </TouchableOpacity>
                <ScrollView  keyboardShouldPersistTaps={"handled"}  contentContainerStyle={{ paddingBottom: 150 }} showsVerticalScrollIndicator={false}>
                    {title && (
                        <BreeSerifText fontSize={RFValue(20)} style={styles.title}>
                            {title || ""}
                        </BreeSerifText>
                    )}
                    <View style={styles.modalContent}>{children}</View>
                </ScrollView>
                {footer && <View>{footer}</View>}
            </View>
        </Modal>
    )
}

export default CustomScrollableModal
